export default "__VITE_ASSET__DUR3RVbo__"